import { CheckCircle2 } from 'lucide-react';
import { useState } from 'react';

interface SiteHighlight {
  title: string;
  description: string;
}

export function KeyHighlights({ highlights }: { highlights?: SiteHighlight[] }) {
  const [expanded, setExpanded] = useState(false);
  if (!highlights?.length) return null;

  const visible = expanded ? highlights : highlights.slice(0, 2);
  const hasMore = highlights.length > 2;

  return (
    <div className="relative mb-4 overflow-hidden rounded-xl border border-(--pill-border) bg-white p-5">
      <ul className="space-y-3">
        {visible.map((h, i) => (
          <li key={i} className="flex gap-2.5">
            <CheckCircle2 className="text-primary mt-0.5 h-4 w-4 flex-shrink-0" />
            <p className="text-sm text-gray-700">
              <strong className="font-semibold text-gray-900">{h.title}: </strong>
              {h.description}
            </p>
          </li>
        ))}
      </ul>
      {hasMore && (
        <button onClick={() => setExpanded((e) => !e)} className="text-primary mt-3 text-sm font-medium hover:underline">
          {expanded ? 'Thu gọn ^' : 'Xem thêm ›'}
        </button>
      )}
      <span className="pointer-events-none absolute right-4 bottom-3 text-3xl opacity-60 select-none" aria-hidden="true">
        👍
      </span>
    </div>
  );
}
